import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import AtSignIcon from "@redotech/redo-icons/at-sign_filled.svg";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export function createMentionsAdvancedFilter(
  effectApi?: EffectApiContext,
): ArrayStringTableFilter<string> {
  return {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: AtSignIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: supportTicketFilterData[SupportTicketFilterNames.MENTIONS],
    itemLabel: "mention",
    itemLabelPlural: "mentions",
    displayName: "Mentions",
    dbSearch: true,
    valueFetcher: effectApi
      ? async (_params, _signal) => {
          // TODO: Implement fetching mentioned users from the API
          return [];
        }
      : undefined,
    display: (item: string) => item,
  };
}
